import { useEffect } from 'react'
import { TFunction, useTranslation } from 'react-i18next'

import { useAppSelector } from '../store'

export const useI18n = (): { t: TFunction<'translation', undefined> } => {
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { locale } = settings
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (!locale) return
    i18n.changeLanguage(locale.language)
  }, [i18n, locale])
  return { t }
}
